import React, { useState } from "react";
import { useNavigate } from 'react-router-dom'
import { Box, Button, FormHelperText, Grid2, MobileStepper, Tab, Tabs, TextField, ThemeProvider, Typography, createTheme, styled, useTheme } from '@mui/material'
import Headernp from "./Partials/Headernp";
import Footer from "./Partials/Footer";
import styles from "../styles/ProjectList.module.css";
import { useThemeContext } from 'components/ui-components/ThemeContext';
import { useAddProjectMutation } from '../store/slices/apis/projectApiSlice';
import { closeSnackbar, openSnackbar } from '../store/slices/snackbar';
import { useDispatch } from '../store';


const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: "none", // Prevent uppercase
    fontWeight: "400",
    fontSize: "16px",
    color: "#696969",
    padding: '0px 10px',
    minHeight: '0px',
    cursor: 'auto',
    "&.Mui-selected": {
        color: "#696969", // Selected tab color
    },
    "&.Mui-disabled": {
        color: "#696969", // Selected tab color
    },

}));

const colors = [
    "#C05222",
    "#415385",
    "#3E756D",
    "#C84757",
    "#CE412D",
    "#2D2D2D",
];

const intitalFormOneError = {
    'project_name': '',
    'start_date': '',
    'end_date': '',
    'client_business_name': '',
    'contractor_business_name': '',
    'discription': '',
    'project_type': '',
    'contractor_number': '',
};

const intitalFormTwoError = {
    'address_line_1': '',
    'address_line_2': '',
    'city': '',
    'state': '',
    'zipcode': ''
};

const intitalFormThreeError = {
    'project_manager_name': '',
    'project_manager_designation': '',
    'project_manager_email': '',
    'project_manager_phoneno': '',
    'budgeted_cost': '',
    'invoiced_cost': '',
};

const CreateProject = () => {

    const dispatch = useDispatch();
    const newtheme = useTheme();
    const { setBgColor } = useThemeContext()
    const [activeStep, setActiveStep] = useState(1);
    const [formOneError, setFormOneError] = useState({ ...intitalFormOneError });
    const [formTwoError, setFormTwoError] = useState({ ...intitalFormTwoError });
    const [formThreeError, setFormThreeError] = useState({ ...intitalFormThreeError });

    const navigate = useNavigate();

    const [addProject, { isLoading, error }] = useAddProjectMutation();

    const theme = createTheme({
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        backgroundColor: `${newtheme?.customSettings?.themeColor}`, color: '#FFF', padding: '6px 20px', fontWeight: '500', textTransform: 'none', fontSize: '16px', float: 'right', marginTop: '30px',
                        '&.Mui-disabled': {
                            color: '#fff',
                            fontSize: '16px'
                        }
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        border: '2px solid #e6e6e6', '& .MuiFilledInput-input': {
                            backgroundColor: '#fff',
                            color: '#252525',
                            fontSize: '16px'
                        },
                        '& .MuiFilledInput-root::before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root::after': {
                            borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#696969',
                            fontSize: '14px'
                        },
                        '& .MuiFormLabel-root': {
                            fontSize: '14px'
                        }
                    },
                },
            }
        },
    });

    const [organisationDetail, setOrganisationDetail] = useState({
        //'primary_color': null
        'primary_color': "#C05222"
    });

    const [administratorInfo, setAdministratorInfo] = useState({
        'project_name': null,
        'start_date': null,
        'end_date': null,
        'client_business_name': null,
        'contractor_business_name': null,
        'discription': null,
        'project_type': null,
        'contractor_number': null,
    });

    const handleAdministratorInfo = (event) => {
        const { name, value } = event.target;
        setAdministratorInfo((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const [projectLocationInfo, setProjectLocationInfo] = useState({
        'address_line_1': null,
        'address_line_2': null,
        'city': null,
        'state': null,
        'zipcode': null
    });

    const handleProjectLocationInfo = (event) => {
        const { name, value } = event.target;
        setProjectLocationInfo((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const [contactBudgetInfo, setContactBudgetInfo] = useState({
        'project_manager_name': null,
        'project_manager_designation': null,
        'project_manager_email': null,
        'project_manager_phoneno': null,
        'budgeted_cost': null,
        'invoiced_cost': null,
    });

    const handleContactBudgetInfo = (event) => {
        const { name, value } = event.target;
        setContactBudgetInfo((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    // Check if any value is null
    const isAdministratorDisabled = Object.values(administratorInfo).some(value => value === null || value === "");
    const isProjectLocationDisabled = Object.values(projectLocationInfo).some(value => value === null || value === "");
    const isContactBudgetInfoDisabled = Object.values(contactBudgetInfo).some(value => value === null || value === "");

    // const handleSelectPrimaryColor = (color) => {
    //     console.log(color);
    //     localStorage.setItem("primary_color", color);
    //     setBgColor(color);
    //     setOrganisationDetail((prevState) => ({
    //         ...prevState,
    //         ['primary_color']: color === organisationDetail?.primary_color ? null : color
    //     }));
    // }

    const openNotification = async (msg, type = 'error') => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), 3000);
    };

    // Project Info Form
    const handleValidateProjectBlur = (event, keyName) => {
        const { name, value } = event.target;
        validateFieldFormOne(name, value, keyName);
    };

    const validateFieldFormOne = (name, value, keyName) => {

        let error = "";

        if (!value?.trim()) {
            error = `${keyName} field is required.`;
        }
        setFormOneError((prev) => ({ ...prev, [name]: error }));
        return error;
    };

    const handleValidateProjectInfo = () => {
        const validateFields = ["project_name", "start_date", "end_date", "client_business_name", "contractor_business_name", "discription", "project_type", "contractor_number"];
        const keyFields = ["Project Name", "Start Date", "End Date", "Client Business Name", "Contractor Business Name", "Project Description", "Project Type", "Contractor Number"];
        let errors = {};
        let isValid = true;
        let startDate = administratorInfo['start_date'];
        let endDate = administratorInfo['end_date'];

        validateFields.forEach((field, key) => {
            const error = validateFieldFormOne(field, administratorInfo[field], keyFields[key]);
            if (error) {
                isValid = false;
            }
        });

        if (startDate && endDate) {
            if (endDate < startDate) {
                setFormOneError((prev) => ({ ...prev, ['end_date']: 'End date should be greater or equal to start date.' }));
                isValid = false;
            }
        }

        return isValid;
    };

    const handleSubmitProjectInfo = async (event) => {

        if (handleValidateProjectInfo()) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }
    // Project Info Form

    // Project Location Info Form
    const validateFieldFormTwo = (name, value, keyName) => {

        const zipcodeRegex = /^[0-9\b]+$/;
        let error = "";

        if (!value?.trim()) {
            error = `${keyName} field is required.`;
        } else {
            switch (name) {
                case "zipcode":
                    if (!zipcodeRegex.test(value)) {
                        error = "Please enter valid zipcode.";
                    }
                    break;

                default:
                    break;
            }
        }
        setFormTwoError((prev) => ({ ...prev, [name]: error }));
        return error;
    };

    const handleValidateProjectLocationInfo = () => {
        const validateFields = ["address_line_1", "address_line_2", "city", "state", "zipcode"];
        const keyFields = ["Address Line 1", "Address Line 2", "City", "State", "Zipcode"];
        let errors = {};
        let isValid = true;

        validateFields.forEach((field, key) => {
            const error = validateFieldFormTwo(field, projectLocationInfo[field], keyFields[key]);
            if (error) {
                isValid = false;
            }
        });

        return isValid;
    };

    const handleValidateProjectLocationBlur = (event, keyName) => {
        const { name, value } = event.target;
        validateFieldFormTwo(name, value, keyName);
    };

    const handleSubmitProjectLocationInfo = async (event) => {

        if (handleValidateProjectLocationInfo()) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1.4);
        }
    }
    // Project Location Info Form

    // Project Contact Info Form
    const handleValidateProjectContactBudgetBlur = (event, keyName) => {
        const { name, value } = event.target;
        validateFieldFormThree(name, value, keyName);
    };

    const validateFieldFormThree = (name, value, keyName) => {

        const phoneRegex = /^\+\d{10,15}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const costRegex = /^\d{1,12}$/;
        let error = "";

        if (!value?.trim()) {
            error = `${keyName} field is required.`;
        } else {
            switch (name) {
                case "project_manager_email":
                    if (!emailRegex.test(value)) {
                        error = "Please enter a valid email address.";
                    }
                    break;
                case "project_manager_phoneno":
                    if (!phoneRegex.test(value)) {
                        error = "Phone Number must start with + and be 10 to 15 digits long.";
                    }
                    break;
                case "budgeted_cost":
                    if (!costRegex.test(value)) {
                        error = "Please enter valid budgeted cost (only numbers).";
                    }
                    break;
                case "invoiced_cost":
                    if (!costRegex.test(value)) {
                        error = "Please enter valid invoiced cost (only numbers).";
                    }
                    break;

                default:
                    break;
            }
        }
        setFormThreeError((prev) => ({ ...prev, [name]: error }));
        return error;
    };

    const handleValidateProjectContactBudgetInfo = () => {
        const validateFields = ["project_manager_name", "project_manager_designation", "project_manager_email", "project_manager_phoneno", "budgeted_cost", "invoiced_cost"];
        const keyFields = ["Full Name", "Designation", "Work Email", "Phone Number", "Project Budgeted Cost", "Project Awarded Cost"];
        let errors = {};
        let isValid = true;

        validateFields.forEach((field, key) => {
            const error = validateFieldFormThree(field, contactBudgetInfo[field], keyFields[key]);
            if (error) {
                isValid = false;
            }
        });

        return isValid;
    };

    const handleAddProject = async (event) => {
        event.preventDefault();

        if (handleValidateProjectContactBudgetInfo()) {
            try {
                const finalData = { ...administratorInfo, ...projectLocationInfo, ...contactBudgetInfo };
                const response = await addProject(finalData);

                if (response?.data.status == 'success') {
                    //openNotification(response?.data.message, 'success');
                    openNotification('Project created successfully.', 'success');
                    navigate("/projects/project-creation/project-list");
                }
                else {
                    openNotification(response?.data.message);
                }
            } catch (error) {
                openNotification(error?.data.message);
            }
        }
    }
    // Project Contact Info Form

    return (
        <>
            <Headernp />
            <div className={styles.layout} style={{ marginTop: '67px' }}>
                <div className={styles.main}>
                    <div className={styles.content}>
                        <ThemeProvider theme={theme}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                            >
                                <Grid2 container>
                                    <Grid2 size={12}>
                                        <Typography
                                            variant="h2"
                                            gutterBottom
                                            textAlign={"center"}
                                            sx={{ color: '#696969', fontWeight: "400", marginBottom: '0px', marginTop: { xs: '10px', sm: '60px' }, fontSize: "45px", opacity: "0.7", letterSpacing: "1px" }}
                                        >
                                            Create a Project
                                        </Typography>
                                    </Grid2>

                                    <Grid2 size={{ xs: 12, md: 4 }} offset={{ md: 4 }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexDirection: 'column',
                                                mt: 2
                                            }}
                                        >
                                            <Tabs
                                                aria-label="basic tabs example"
                                                centered
                                                sx={{
                                                    minHeight: '0px',
                                                    "& .MuiTabs-indicator": { display: "none" },
                                                }}
                                            >
                                                <StyledTab label="Project Info" disabled style={{ minWidth: "23%" }} />
                                                <StyledTab label="Location" disabled style={{ minWidth: "23%" }} />
                                                <StyledTab label="Contact Info" disabled style={{ minWidth: "23%" }} />
                                            </Tabs>
                                            <MobileStepper
                                                variant="progress"
                                                steps={4.4}
                                                position="relative"
                                                activeStep={activeStep}
                                                sx={{
                                                    width: "100%", flexGrow: 1, background: 'none', padding: '0px', justifyContent: 'center', mt: 1,
                                                    "& .MuiLinearProgress-root": {
                                                        backgroundColor: "#E8E8E8", // Line background color
                                                        width: '72%',
                                                        borderRadius: "2px",
                                                        height: "3px"
                                                    },
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: `${newtheme?.customSettings?.themeColor}`, // Progress bar color
                                                    },

                                                }}

                                            />
                                        </Box>
                                    </Grid2>
                                    {/* first setup */}
                                    {activeStep == 1 &&
                                        <Grid2 size={{ xs: 12, md: 6 }} offset={{ md: 3 }}>
                                            <Typography
                                                variant="h3"
                                                gutterBottom
                                                sx={{
                                                    mt: 4
                                                }}
                                                style={{ color: '#696969', fontWeight: "500", fontSize: '24px', marginBottom: "20px", textAlign: "center" }}
                                            >
                                                Project Info
                                            </Typography>
                                            <Box sx={{ width: { xs: '100%', sm: '100%' }, mt: 2 }}>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#474747', fontWeight: "400", fontSize: '16px', marginBottom: "20px" }}
                                                >
                                                    Here you can customise the look and feel of the application. These settings will be visible to all users of the app,
                                                    so make sure to choose options that best represent your brand.
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#696969', fontWeight: "500", fontSize: '20px' }}
                                                >
                                                    Project Name, Client Name, Contractor Name and Duration
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#696969', fontWeight: "400", fontSize: '16px' }}
                                                >
                                                    Enter a unique name for your project.&nbsp;
                                                    <span style={{ color: `${newtheme?.customSettings?.themeColor}`, cursor: 'pointer', textDecoration: "underline", fontStyle: "solid" }} >More info.</span>
                                                </Typography>

                                                <Grid2 container spacing={2}>
                                                    <Grid2 size={12}>
                                                        <TextField
                                                            label="Project Name"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: Roshan Patel"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="project_name"
                                                            value={administratorInfo?.project_name}
                                                            onChange={handleAdministratorInfo}
                                                            onBlur={(event) => handleValidateProjectBlur(event, 'Project Name')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formOneError?.project_name &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formOneError?.project_name}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 6 }}>
                                                        <TextField
                                                            type="date"
                                                            label="Start Date"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="mm/dd/yyyy"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                                "& .MuiFormLabel-asterisk": {
                                                                    color: "red",
                                                                    fontSize: 20,
                                                                }
                                                            }}
                                                            name="start_date"
                                                            value={administratorInfo?.start_date}
                                                            onChange={handleAdministratorInfo}
                                                            onBlur={(event) => handleValidateProjectBlur(event, 'Start Date')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                            required
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        />
                                                        {formOneError?.start_date &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formOneError?.start_date}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 6 }}>
                                                        <TextField
                                                            type="date"
                                                            label="End Date"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="mm/dd/yyyy"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                                "& .MuiFormLabel-asterisk": {
                                                                    color: "red",
                                                                    fontSize: 20,
                                                                }
                                                            }}
                                                            name="end_date"
                                                            value={administratorInfo?.end_date}
                                                            onChange={handleAdministratorInfo}
                                                            onBlur={(event) => handleValidateProjectBlur(event, 'End Date')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                            required
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        />
                                                        {formOneError?.end_date &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formOneError?.end_date}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={12}>
                                                        <TextField
                                                            label="Client Business Name"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: GMR Pte"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="client_business_name"
                                                            value={administratorInfo?.client_business_name}
                                                            onChange={handleAdministratorInfo}
                                                            onBlur={(event) => handleValidateProjectBlur(event, 'Client Business Name')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formOneError?.client_business_name &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formOneError?.client_business_name}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={12}>
                                                        <TextField
                                                            label="Contractor Business Name"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: L&T Ltd."
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="contractor_business_name"
                                                            value={administratorInfo?.contractor_business_name}
                                                            onChange={handleAdministratorInfo}
                                                            onBlur={(event) => handleValidateProjectBlur(event, 'Contractor Business Name')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formOneError?.contractor_business_name &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formOneError?.contractor_business_name}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 6 }}>
                                                        <TextField
                                                            label="Project Type"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: ABCDEF"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="project_type"
                                                            value={administratorInfo?.project_type}
                                                            onChange={handleAdministratorInfo}
                                                            onBlur={(event) => handleValidateProjectBlur(event, 'Project Type')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formOneError?.project_type &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formOneError?.project_type}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 6 }}>
                                                        <TextField
                                                            label="Contractor Number"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: ABd&127821679212cf71s"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="contractor_number"
                                                            value={administratorInfo?.contractor_number}
                                                            onChange={handleAdministratorInfo}
                                                            onBlur={(event) => handleValidateProjectBlur(event, 'Contractor Number')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formOneError?.contractor_number &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formOneError?.contractor_number}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={12}>
                                                        <TextField
                                                            label="Project Description"
                                                            variant="filled"
                                                            fullWidth
                                                            multiline
                                                            rows={4}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: 12,
                                                                    fontWeight: 400,
                                                                },
                                                            }}
                                                            sx={{
                                                                textarea: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                                ".MuiFilledInput-root": {
                                                                    backgroundColor: "#ffffff",

                                                                    "&:hover": {
                                                                        backgroundColor: "#ffffff",
                                                                    },
                                                                    "&.Mui-focused": {
                                                                        backgroundColor: "#ffffff",
                                                                        boxShadow: "none",
                                                                    },
                                                                    // "&.Mui-error": {
                                                                    //     backgroundColor: "#ffffff",
                                                                    // },
                                                                },
                                                            }}
                                                            placeholder="Ex: Project Details"
                                                            name="discription"
                                                            value={administratorInfo?.discription}
                                                            onChange={handleAdministratorInfo}
                                                            onBlur={(event) => handleValidateProjectBlur(event, 'Project Description')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formOneError?.discription &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formOneError?.discription}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                </Grid2>
                                            </Box>
                                            {/* <Box sx={{ width: "100%", mt: 3 }}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        style={{ color: '#474747', fontWeight: "400", fontSize: '16px' }}
                                    >
                                        Choose an Avatar
                                    </Typography>
                                    {colors.map((color, index) => (
                                        <IconButton key={index} onClick={() => handleSelectPrimaryColor(color)} sx={{ margin: '0px 10px 0px 0px', padding: '0px' }}>
                                            {organisationDetail?.primary_color === color ? (
                                                <FaCircleCheck style={{ color, fontSize: "30" }} />
                                            ) : (
                                                <FaCircle style={{ color, fontSize: "30" }} />
                                            )}
                                        </IconButton>
                                    ))}

                                </Box> */}
                                            <Box sx={{ width: { xs: '100%', sm: '100%' }, mt: 2 }}>
                                                <Button onClick={handleSubmitProjectInfo}>
                                                    Save and Continue
                                                </Button>
                                            </Box>
                                        </Grid2>
                                    }
                                    {/* 2nd setup */}
                                    {activeStep == 2 &&
                                        <Grid2 size={{ xs: 12, md: 6 }} offset={{ md: 3 }}>
                                            <Typography
                                                variant="h3"
                                                gutterBottom
                                                sx={{
                                                    mt: 4
                                                }}
                                                style={{ color: '#696969', fontWeight: "500", fontSize: '24px', marginBottom: "20px", textAlign: "center", letterSpacing: "0.4px", lineHeight: "32px" }}
                                            >
                                                Project Location
                                            </Typography>
                                            <Box sx={{ width: { xs: '100%', sm: '100%' }, mt: 2 }}>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#474747', fontWeight: "400", fontSize: '16px', marginBottom: "20px" }}
                                                >
                                                    Here you can customise the look and feel of the application. These settings will be visible to all users of the app,
                                                    so make sure to choose options that best represent your brand.
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#696969', fontWeight: "500", fontSize: '20px', letterSpacing: "0.4px", lineHeight: "24px" }}
                                                >
                                                    Project Location
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#696969', fontWeight: "400", fontSize: '16px' }}
                                                >
                                                    You have uploaded your logo successfully.&nbsp;
                                                    <span style={{ color: `${newtheme?.customSettings?.themeColor}`, cursor: 'pointer', textDecoration: "underline", fontStyle: "solid" }} >More info.</span>
                                                </Typography>

                                                <Grid2 container spacing={2}>
                                                    <Grid2 size={12}>
                                                        <TextField
                                                            label="Address Line 1"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: 1176, Kedar Nath, Near Doon Unv."
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="address_line_1"
                                                            value={projectLocationInfo?.address_line_1}
                                                            onChange={handleProjectLocationInfo}
                                                            onBlur={(event) => handleValidateProjectLocationBlur(event, 'Address Line 1')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formTwoError?.address_line_1 &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formTwoError?.address_line_1}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 7 }}>
                                                        <TextField
                                                            label="Address Line 2"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: Defence Colony."
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="address_line_2"
                                                            value={projectLocationInfo?.address_line_2}
                                                            onChange={handleProjectLocationInfo}
                                                            onBlur={(event) => handleValidateProjectLocationBlur(event, 'Address Line 2')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formTwoError?.address_line_2 &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formTwoError?.address_line_2}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 5 }}>
                                                        <TextField
                                                            label="City"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: Dehradun"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="city"
                                                            value={projectLocationInfo?.city}
                                                            onChange={handleProjectLocationInfo}
                                                            onBlur={(event) => handleValidateProjectLocationBlur(event, 'City')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formTwoError?.city &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formTwoError?.city}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 7 }}>
                                                        <TextField
                                                            label="State"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: Uttarakhand"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="state"
                                                            value={projectLocationInfo?.state}
                                                            onChange={handleProjectLocationInfo}
                                                            onBlur={(event) => handleValidateProjectLocationBlur(event, 'State')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formTwoError?.state &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formTwoError?.state}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 5 }}>
                                                        <TextField
                                                            label="Zipcode"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: 242424"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="zipcode"
                                                            value={projectLocationInfo?.zipcode}
                                                            onChange={handleProjectLocationInfo}
                                                            onBlur={(event) => handleValidateProjectLocationBlur(event, 'Zipcode')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formTwoError?.zipcode &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formTwoError?.zipcode}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                </Grid2>
                                            </Box>

                                            <Box sx={{ width: '100%', mt: 2 }}>
                                                <Button onClick={handleSubmitProjectLocationInfo}>
                                                    Save and Continue
                                                </Button>

                                                <Button onClick={() => {
                                                    setActiveStep(1)
                                                    setFormTwoError({
                                                        ...intitalFormTwoError
                                                    });

                                                    setProjectLocationInfo({
                                                        'address_line_1': '',
                                                        'address_line_2': '',
                                                        'city': '',
                                                        'state': '',
                                                        'zipcode': ''
                                                    })
                                                }} variant='outlined' sx={{
                                                    marginRight: '20px',
                                                    color: `${newtheme?.customSettings?.themeColor}`,
                                                    border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                                                    background: 'none'
                                                }}>
                                                    Back
                                                </Button>
                                            </Box>
                                        </Grid2>
                                    }
                                    {/* 3rd setup value is 3.4 */}
                                    {activeStep == 3.4 &&
                                        <Grid2 size={{ xs: 12, md: 6 }} offset={{ md: 3 }}>
                                            <Typography
                                                variant="h3"
                                                gutterBottom
                                                sx={{
                                                    mt: 4
                                                }}
                                                style={{ color: '#696969', fontWeight: "500", fontSize: '24px', marginBottom: "20px", textAlign: "center" }}
                                            >
                                                Contact Info & Budgets
                                            </Typography>
                                            <Box sx={{ width: '100%', mt: 2 }}>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#474747', fontWeight: "400", fontSize: '16px', marginBottom: "20px" }}
                                                >
                                                    Here you can customise the look and feel of the application. These settings will be visible to all users of the app,
                                                    so make sure to choose options that best represent your brand.
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#696969', fontWeight: "500", fontSize: '20px' }}
                                                >
                                                    Project Manager and Budget Info
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    gutterBottom
                                                    style={{ color: '#696969', fontWeight: "400", fontSize: '16px' }}
                                                >
                                                    You have uploaded your logo successfully.&nbsp;
                                                    <span style={{ color: `${newtheme?.customSettings?.themeColor}`, cursor: 'pointer', textDecoration: "underline", fontStyle: "solid" }} >More info.</span>
                                                </Typography>

                                                <Grid2 container spacing={2}>
                                                    <Grid2 size={12}>
                                                        <TextField
                                                            label="Full Name"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: Roshan Patel"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="project_manager_name"
                                                            value={contactBudgetInfo?.project_manager_name}
                                                            onChange={handleContactBudgetInfo}
                                                            onBlur={(event) => handleValidateProjectContactBudgetBlur(event, 'Full Name')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formThreeError?.project_manager_name &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formThreeError?.project_manager_name}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={12}>
                                                        <TextField
                                                            label="Designation"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: Senior Project Manager"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="project_manager_designation"
                                                            value={contactBudgetInfo?.project_manager_designation}
                                                            onChange={handleContactBudgetInfo}
                                                            onBlur={(event) => handleValidateProjectContactBudgetBlur(event, 'Designation')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formThreeError?.project_manager_designation &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formThreeError?.project_manager_designation}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 7 }}>
                                                        <TextField
                                                            label="Work Email"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: roshanpatel@example.com"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="project_manager_email"
                                                            value={contactBudgetInfo?.project_manager_email}
                                                            onChange={handleContactBudgetInfo}
                                                            onBlur={(event) => handleValidateProjectContactBudgetBlur(event, 'Work Email')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formThreeError?.project_manager_email &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formThreeError?.project_manager_email}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 5 }}>
                                                        <TextField
                                                            label="Phone Number"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: +48692462966"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="project_manager_phoneno"
                                                            value={contactBudgetInfo?.project_manager_phoneno}
                                                            onChange={handleContactBudgetInfo}
                                                            onBlur={(event) => handleValidateProjectContactBudgetBlur(event, 'Phone Number')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formThreeError?.project_manager_phoneno &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formThreeError?.project_manager_phoneno}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 7 }}>
                                                        <TextField
                                                            label="Project Budgeted Cost"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: 2.4B"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="budgeted_cost"
                                                            value={contactBudgetInfo?.budgeted_cost}
                                                            onChange={handleContactBudgetInfo}
                                                            onBlur={(event) => handleValidateProjectContactBudgetBlur(event, 'Project Budgeted Cost')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formThreeError?.budgeted_cost &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formThreeError?.budgeted_cost}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                    <Grid2 size={{ xs: 12, md: 5 }}>
                                                        <TextField
                                                            label="Project Awarded Cost"
                                                            variant="filled"
                                                            fullWidth
                                                            inputProps={{ style: { height: "24px", }, }}
                                                            InputLabelProps={{ style: { fontSize: 12, fontWeight: 400 }, }}
                                                            placeholder="Ex: 3.4B"
                                                            sx={{
                                                                input: {
                                                                    "&::placeholder": {
                                                                        fontSize: 16,
                                                                        fontWeight: 400,
                                                                    },
                                                                },
                                                            }}
                                                            name="invoiced_cost"
                                                            value={contactBudgetInfo?.invoiced_cost}
                                                            onChange={handleContactBudgetInfo}
                                                            onBlur={(event) => handleValidateProjectContactBudgetBlur(event, 'Project Awarded Cost')}
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                        />
                                                        {formThreeError?.invoiced_cost &&
                                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${formThreeError?.invoiced_cost}`}</FormHelperText>
                                                        }
                                                    </Grid2>
                                                </Grid2>
                                            </Box>

                                            <Box sx={{ width: "100%", mt: 2 }}>
                                                <Button onClick={handleAddProject} disabled={isLoading}>
                                                    {isLoading ? 'Adding...' : 'Save and Continue'}
                                                </Button>
                                                {error && <p>Error creating project: {error.message}</p>}

                                                <Button onClick={() => {
                                                    setActiveStep(2)
                                                    setFormThreeError({
                                                        ...intitalFormThreeError
                                                    });

                                                    setContactBudgetInfo({
                                                        'project_manager_name': '',
                                                        'project_manager_designation': '',
                                                        'project_manager_email': '',
                                                        'project_manager_phoneno': '',
                                                        'budgeted_cost': '',
                                                        'invoiced_cost': '',
                                                    })
                                                }} variant='outlined' sx={{
                                                    marginRight: '20px',
                                                    color: `${newtheme?.customSettings?.themeColor}`,
                                                    border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                                                    background: 'none'
                                                }}>
                                                    Back
                                                </Button>
                                            </Box>
                                        </Grid2>
                                    }
                                </Grid2>
                            </Box>
                        </ThemeProvider>
                    </div>
                </div>
                <Footer />
            </div>
        </>

    )
}

export default CreateProject;